<template>
    <nav class="c-m-mypages-menu">
        <div class="c-m-mypages-menu__list" id="mypages-menu__list">
            <router-link class="c-m-mypages-menu__item"
                v-for="(route, index) in routes"
                :to="{name: route.name}"
                :key="index">
                <icon :icon="setIcon(route)"></icon>
                <span class="c-m-mypages-menu__name">{{route.name}}</span>
            </router-link>
        </div>
    </nav>
</template>

<script>
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        components: {
            Icon
        },
        props: {
            routes: Array
        },
        methods: {
            setIcon(route){
                if(route.name === 'Förfrågningar'){
                    return 'list';
                }
                if(route.name === 'Profil'){
                    return 'info';
                }
                if(route.name === 'Mitt konto'){
                    return 'person';
                }
                if(route.name === 'Sökprofil'){
                    return 'search';
                }
                if(route.name === 'Meddelanden'){
                    return 'mail';
                }
            }
        }
    }

</script>




// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeMyPagesMenu.vue